import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { PagingController } from '../../../shared/commons/paging-controller/paging-controller';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { BasePageComponent } from '../../commons/base-page/base-page.component';
import { LabelP } from '../../../data/cms-vod-client-api';
import { VodDataRestService } from '../../../data/vod/vod-data-rest.service';


@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.css'],
  providers: [PagingController]
})
export class ContentListComponent extends BasePageComponent implements OnInit {

  categories: LabelP[] = [];

  constructor(helpers: HelpersService,
    private vodService: VodDataRestService,
  ) {
    super(helpers);
    this.vodService.getAllLabels().subscribe(data => { 
      this.categories = data;
      // console.log("category:", this.categories)
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/content-list/content-list.component.ts